import React from 'react';

export function Sandwich () {
    return (
        <aside class = 'sandwich'>
            <div>
                <h4>Browse</h4>
            </div>
            <div>
            <h4>Library</h4>
            </div>
            <div>
            <h4>Playlists</h4>
            </div>
        </aside>
    )
}